import { simplybusinessUkAmbles } from "./simplybusiness-uk";
import { simplybusinessUsAmbles } from "./simplybusiness-us";
import { siteAmbles } from "./sites";

export type Ambles = {
  siteAmbles: Record<string, Record<string, string>>;
  simplybusinessUkAmbles: Record<string, string>;
  simplybusinessUsAmbles: Record<string, string>;
};

/**
 * Amble registry organized by priority: sites, then locale-specific.
 * Used by getAmble for the lookup cascade.
 */
export const ambles: Ambles = {
  siteAmbles,
  simplybusinessUkAmbles,
  simplybusinessUsAmbles,
};
